<!--  -->
<template>
  <div>
    <div id="id_test_video" style="width:100%; height:auto;"></div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { TcPlayer } from '@/utils/TcPlayer3.2.3'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      p: null,
      dataSource: null
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  beforeDestroy() {
    this.playDestroy()
  },
  // 方法集合
  methods: {
    playerInit() {
      let _this = this;
      let liveTip = '主播已下线';
      // let str = "http://1251264866.vod2.myqcloud.com/fe7ebb8bvodcq1251264866/2b0694425285890811144309630/playlist.f5.mp4";
      // let str = 'https://live-play.tencent-cloud.com/live/21459_salon_1348.m3u8';
      // let str = this.dataSource.liveUrl
      let str = this.$route.query.liveUrl
      if (this.$route.query.txTime) {
        str = this.$route.query.liveUrl + '&txTime=' + this.$route.query.txTime
      }
      let flv = str.replace('.m3u8', '.flv')
      // console.log(str)
      // let str = "https://live.eastfair.cn/iMaster/PRODjK8Y0dNz.m3u8?txSecret=8c9808c0bb239fd97a4280edb1394fed&txTime=607721F7"
      let mp4 = str.replace('.m3u8', '.mp4')
      _this.playDestroy();
      var controls = "system";
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
      if (isAndroid) {
        controls = "default";
      }
      _this.p = new TcPlayer('id_test_video', {
            controls: controls,
            live: true,
            m3u8: str,
            flv: flv, //增加了一个 flv 的播放地址，用于PC平台的播放 请替换成实际可用的播放地址
            // rtmp:str,
            mp4: mp4,
            autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
            // poster: {"style":"cover", "src":this.dataSource.liveImgUrl},
            wording: {
              2: '视频格式 Web 播放器无法解码。',
              3: '视频解码错误。',
              4: '当前系统环境不支持播放该视频格式。',
              5: '当前系统环境不支持播放该视频格式。',
              1001: '网络已断开',
              1002: liveTip,
              2032: '获取视频失败，请检查播放链接是否有效。',
              2048: '无法加载视频文件，跨域访问被拒绝。'
            },
            listener: function(msg) {
              console.log(msg);
              // if (msg.type == 'error') {
              //   console.log(msg)
              // } else if (msg.type == 'play') {
              //   _this.startWatchLog()
              // } else if (msg.type == 'ended') {
              //   _this.stopWatchLog()
              // }
            },
            width: window.screen.width, //视频的显示宽度，请尽量使用视频分辨率宽度
            height: window.innerHeight //视频的显示高度，请尽量使用视频分辨率高度
          })
    },
    // 直播组件销毁
    playDestroy() {
        if (this.p) {
            this.p.destroy()
            this.p = null
        }
    },
    getLive() {
      var params = {"liveId":902,"languageType":"cn","exhibitionId":"256cef9c35b34141a93a1a5174df6458","appId":"d446b2877b7041a8b7b76208cbb465fe","terminal":"web","subjectType":"VISITOR"}
      this.$http.live(params).then(res => {
        this.dataSource = res.data;
        console.log(this.dataSource);
        this.playerInit();
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // this.getLive();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.playerInit();
    var _this = this;
    document.addEventListener('visibilitychange', function () {
      // 用户离开了当前页面
      if (document.visibilityState == 'hidden') {
        _this.p.pause();
      }
    
      // 用户打开或回到页面
      if (document.visibilityState == 'visible') {
        if (_this.p) {
          _this.p.play();//播放 
        }
      }
    });
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
